import { render } from "./bubble.vue?vue&type=template&id=321f2b93"
import script from "./bubble.vue?vue&type=script&lang=js"
export * from "./bubble.vue?vue&type=script&lang=js"

import "./bubble.vue?vue&type=style&index=0&id=321f2b93&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__